import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../../api/apiClient";
import {
  fetchSensorsStart,
  fetchSensorsSuccess,
  fetchSensorsFailure,
  fetchUnassignedSensorsSuccess,
  fetchUnassignedSensorsStart,
} from "../../../store/features/customer/instruments/sensorsSlice";

const URL = buildApiUrl("/api/v1/instruments/sensor/");

const getSensorsApi = async (accessToken, field = "", has_field) => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
      params: {
        field: field || null,
        has_field: has_field,
        _: Date.now(),
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchSensorsSaga(action) {
  try {
    const { accessToken, field } = action.payload || {};
    const sensorsData = yield call(getSensorsApi, accessToken, field);
    yield put(fetchSensorsSuccess(sensorsData));
  } catch (error) {
    yield put(fetchSensorsFailure(error.message));
  }
}

function* fetchUnassignedSensorsSaga(action) {
  try {
    const { accessToken, has_field } = action.payload || {};
    const unassignedSensorsData = yield call(
      getSensorsApi,
      accessToken,
      "",
      has_field
    );
    yield put(fetchUnassignedSensorsSuccess(unassignedSensorsData));
  } catch (error) {
    yield put(fetchSensorsFailure(error.message));
  }
}

export default function* sensorsSaga() {
  yield takeLatest(fetchSensorsStart.type, fetchSensorsSaga);
  yield takeLatest(
    fetchUnassignedSensorsStart.type,
    fetchUnassignedSensorsSaga
  );
}
